import type { HostComponent, ViewProps } from 'react-native';
import type { DirectEventHandler, Double, Int32 } from 'react-native/Libraries/Types/CodegenTypes';
import codegenNativeCommands from 'react-native/Libraries/Utilities/codegenNativeCommands';
import codegenNativeComponent from 'react-native/Libraries/Utilities/codegenNativeComponent';
import type * as React from 'react';
interface NativeProps extends ViewProps {
  active: boolean;
  facing: string;
  codeTypes: ReadonlyArray<string>;
  flash: string;
  enableTorch: boolean;
  zoom: Double;
  onNativeCameraState?: DirectEventHandler<Readonly<{
    state: string;
  }>>;
  onNativeCameraCode?: DirectEventHandler<Readonly<{
    type: string;
    data: string;
  }>>;
  // error is empty on success, otherwise "<code>: <message>".
  onNativeCameraPicture?: DirectEventHandler<Readonly<{
    requestId: Int32;
    uri: string;
    width: Int32;
    height: Int32;
    base64: string;
    error: string;
  }>>;
}
interface NativeCommands {
  takePicture(viewRef: React.ElementRef<HostComponent<NativeProps>>, requestId: Int32, quality: Double, base64: boolean): void;
}
const NativeComponentRegistry = require('react-native/Libraries/NativeComponent/NativeComponentRegistry');
const {
  ConditionallyIgnoredEventHandlers
} = require('react-native/Libraries/NativeComponent/ViewConfigIgnore');
const {
  dispatchCommand
} = require("react-native/Libraries/ReactNative/RendererProxy");
let nativeComponentName = 'OneNativeCamera';
export const __INTERNAL_VIEW_CONFIG = {
  uiViewClassName: "OneNativeCamera",
  directEventTypes: {
    topNativeCameraState: {
      registrationName: "onNativeCameraState"
    },
    topNativeCameraCode: {
      registrationName: "onNativeCameraCode"
    },
    topNativeCameraPicture: {
      registrationName: "onNativeCameraPicture"
    }
  },
  validAttributes: {
    active: true,
    facing: true,
    codeTypes: true,
    flash: true,
    enableTorch: true,
    zoom: true,
    ...ConditionallyIgnoredEventHandlers({
      onNativeCameraState: true,
      onNativeCameraCode: true,
      onNativeCameraPicture: true
    })
  }
};
export default NativeComponentRegistry.get(nativeComponentName, () => __INTERNAL_VIEW_CONFIG);
export const Commands = {
  takePicture(ref, requestId, quality, base64) {
    dispatchCommand(ref, "takePicture", [requestId, quality, base64]);
  }
};